var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M99.5 54.8V37l-19-17.4H23.2c-2 0-3.7 1.6-3.7 3.7V118c0 2 1.6 3.7 3.7 3.7h72.6c2 0 3.7-1.6 3.7-3.7v-5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M80.5 19.7V37h19M116.9 103H60.8c-2.8 0-5.1-2.3-5.1-5.1V69c0-2.8 2.3-5.1 5.1-5.1h56.1c2.8 0 5.1 2.3 5.1 5.1v28.8c0 2.9-2.3 5.2-5.1 5.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M86.1 77.4V90s9.9 1.5 9.9-6.6c0 0-.3-7.8-9.9-6zM69.6 90V77.4c10.4-1.4 9.9 3.4 9.9 3.4s.7 3.9-8.6 3.6M103.6 90V77.4h7.7M103.6 83.7h7.7M47.6 35s-6.8 21.6-13.2 28.6-9.2 2.9-8.5.5c.8-2.5 7.2-7.4 20.5-10.5s17.2-2.4 19.2-2c2.1.5 4.1 2.5 2.1 4.1-2.2 1.9-6.7 1.3-10-.6S46.6 46.4 43.6 36c-3-10.4 1.3-11.3 1.7-11.3.7-.1 5 .7 2.3 10.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.94f769c313fdfc4dc29d0ee71f1fa478.svg";
export { ForwardRef as ReactComponent };